import { ESmartFilterColumnType } from '@modules/smart-filters/enums';

import type { IReportInnerTabItem, IReportStatsColumn } from '../types';

export const SEGMENTS_INNER_TABS: IReportInnerTabItem[] = [
  {
    id: 300,
    shortcode: 'REPORTS.SEGMENTS_TABS.merchant_ids',
  },
  {
    id: 51,
    shortcode: 'REPORTS.SEGMENTS_TABS.managers',
  },
  {
    id: 52,
    shortcode: 'REPORTS.SEGMENTS_TABS.departments',
  },
  {
    id: 1,
    shortcode: 'REPORTS.SEGMENTS_TABS.affiliates',
  },
  {
    id: 38,
    shortcode: 'REPORTS.SEGMENTS_TABS.tracker_country',
  },
  {
    id: 39,
    shortcode: 'REPORTS.SEGMENTS_TABS.tracker_traffic_source',
  },
  {
    id: 2,
    shortcode: 'REPORTS.SEGMENTS_TABS.trackers',
  },
  {
    id: 3,
    shortcode: 'REPORTS.SEGMENTS_TABS.anid',
  },
  {
    id: 101,
    shortcode: 'REPORTS.SEGMENTS_TABS.anid1',
  },
  {
    id: 102,
    shortcode: 'REPORTS.SEGMENTS_TABS.anid2',
  },
  {
    id: 103,
    shortcode: 'REPORTS.SEGMENTS_TABS.anid3',
  },
  {
    id: 104,
    shortcode: 'REPORTS.SEGMENTS_TABS.anid4',
  },
  {
    id: 105,
    shortcode: 'REPORTS.SEGMENTS_TABS.anid5',
  },
  {
    id: 4,
    shortcode: 'REPORTS.SEGMENTS_TABS.creatives',
  },
  {
    id: 5,
    shortcode: 'REPORTS.SEGMENTS_TABS.players',
    uploadFile: true,
  },
  {
    id: 6,
    shortcode: 'REPORTS.SEGMENTS_TABS.stats',
    advancedFilter: true,
  },
  {
    id: 18,
    shortcode: 'REPORTS.SEGMENTS_TABS.invated_affiliates',
  },
  {
    id: 23,
    shortcode: 'REPORTS.SEGMENTS_TABS.creatives_for_creatives_report',
  },
  {
    id: 24,
    shortcode: 'REPORTS.SEGMENTS_TABS.affiliates_for_creatives_report',
  },
  {
    id: 25,
    shortcode: 'REPORTS.SEGMENTS_TABS.trackers_for_creatives_report',
  },
  {
    id: 26,
    shortcode: 'REPORTS.SEGMENTS_TABS.anids_for_creatives_report',
  },
];

export const STRUCTURES_INNER_TABS: IReportInnerTabItem[] = [
  {
    id: 5,
    shortcode: 'REPORTS.STRUCTURES_TABS.general_columns',
  },
  {
    id: 1,
    shortcode: 'REPORTS.STRUCTURES_TABS.player_columns',
  },
  {
    id: 2,
    shortcode: 'REPORTS.STRUCTURES_TABS.product_columns',
  },
  {
    id: 3,
    shortcode: 'REPORTS.STRUCTURES_TABS.comission_columns',
  },
  {
    id: 4,
    shortcode: 'REPORTS.STRUCTURES_TABS.stats_columns',
  },
];

export const STATS_COLUMNS: IReportStatsColumn[] = [
  {
    id: '7',
    shortcode: 'REPORTS.SEGMENTS_TABS.date_of_registration',
    type: ESmartFilterColumnType.DATE,
  },
  {
    id: '8',
    shortcode: 'REPORTS.SEGMENTS_TABS.date_of_ftd',
    type: ESmartFilterColumnType.DATE,
  },
  {
    id: '9',
    shortcode: 'REPORTS.SEGMENTS_TABS.date_of_last_deposit',
    type: ESmartFilterColumnType.DATE,
  },
  {
    id: '10',
    shortcode: 'REPORTS.SEGMENTS_TABS.date_of_last_rmp_activity',
    type: ESmartFilterColumnType.DATE,
  },
  {
    id: '11',
    shortcode: 'REPORTS.SEGMENTS_TABS.inactive_days',
    type: ESmartFilterColumnType.COMPARE,
  },
  {
    id: '12',
    shortcode: 'REPORTS.SEGMENTS_TABS.first_deposit_size',
    type: ESmartFilterColumnType.COMPARE,
  },
  {
    id: '13',
    shortcode: 'REPORTS.SEGMENTS_TABS.last_deposit_size',
    type: ESmartFilterColumnType.COMPARE,
  },
  {
    id: '14',
    shortcode: 'REPORTS.SEGMENTS_TABS.amount_of_deposits',
    type: ESmartFilterColumnType.COMPARE,
  },
  {
    id: '15',
    shortcode: 'REPORTS.SEGMENTS_TABS.average_deposit_size',
    type: ESmartFilterColumnType.COMPARE,
  },
  {
    id: '16',
    shortcode: 'REPORTS.SEGMENTS_TABS.sum_of_deposits',
    type: ESmartFilterColumnType.COMPARE,
  },
  {
    id: '19',
    shortcode: 'REPORTS.SEGMENTS_TABS.ngr_all_time',
    type: ESmartFilterColumnType.COMPARE,
  },
  {
    id: '20',
    shortcode: 'REPORTS.SEGMENTS_TABS.ggr_all_time',
    type: ESmartFilterColumnType.COMPARE,
  },
  {
    id: '21',
    shortcode: 'REPORTS.SEGMENTS_TABS.ngr_this_month',
    type: ESmartFilterColumnType.COMPARE,
  },
  {
    id: '22',
    shortcode: 'REPORTS.SEGMENTS_TABS.ggr_this_month',
    type: ESmartFilterColumnType.COMPARE,
  },
  {
    id: '36',
    shortcode: 'REPORTS.SEGMENTS_TABS.country_code',
    type: ESmartFilterColumnType.CHECKBOX,
  },
];
